// components/SectionTitle.tsx
import React from "react";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  center?: boolean;
}

export default function SectionTitle({
  eyebrow,
  title,
  center,
}: SectionTitleProps) {
  return (
    <div className={`mb-6 ${center ? "text-center" : ""}`}>
      {eyebrow && (
        <div className="mb-2 text-sm font-semibold uppercase tracking-[0.14em] text-white/60">
          {eyebrow}
        </div>
      )}

      <h2 className="text-2xl font-extrabold leading-tight text-white sm:text-3xl">
        {title}
      </h2>
    </div>
  );
}
